import { render, staticRenderFns } from "./IconCashSolid.vue?vue&type=template&id=dbb5b4b0"
import script from "./IconCashSolid.vue?vue&type=script&lang=js"
export * from "./IconCashSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports